import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-format/src/precisionFixed.js
// module id = 277
// module chunks = 0 1 2 3 4